import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import cn from 'clsx'

import { mediaQueryUp } from 'components/utils/breakpoint'
import Clickable from 'components/Common/Clickable'
import BodyText from 'components/Luxkit/Typography/BodyText'
import LinePlaneFlyIcon from 'components/Luxkit/Icons/line/LinePlaneFlyIcon'
import LineArrowRightIcon from 'components/Luxkit/Icons/line/LineArrowRightIcon'

const Root = styled(Clickable)`
  display: flex;
  align-items: center;
  height: ${rem(60)};
  padding: ${rem(12)};
  transition: background-color 0.2s;
  border-top: 1px solid ${props => props.theme.palette.neutral.five};

  &.no-top-border {
    &:first-child {
      border-top: none;

      ${mediaQueryUp.sm} {
        border-top-left-radius: ${props => props.theme.borderRadius.large};
        border-top-right-radius: ${props => props.theme.borderRadius.large};
      }
    }
  }

  &:last-child {
    border-bottom-left-radius: ${props => props.theme.borderRadius.large};
    border-bottom-right-radius: ${props => props.theme.borderRadius.large};
  }

  &.sub-record {
    border-top: none;
    padding-left: ${rem(72)};
  }

  &.selected, &:hover {
    background-color: ${props => props.theme.palette.primary.lightest};
  }
`

const AirportDetails = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${rem(24)};
`

interface Props {
  subRecord: boolean;
  selected?: boolean;
  airport: App.AirportLocation;
  icon?: React.ReactNode;
  onSelectAirport: (airport: App.AirportLocation) => void;
}

function AirportDropdownOption(props: Props) {
  const { subRecord, selected, airport, onSelectAirport } = props
  const { cityDesc, airportName, airportCode } = airport

  const selectAirport = () => onSelectAirport(airport)

  const displayText = subRecord ? `${cityDesc} (${airportName})` : airportName

  return (
    <Root className={cn('no-top-border', { 'sub-record': subRecord, selected })} onClick={selectAirport} data-testid={displayText}>
      {subRecord ? <LineArrowRightIcon /> : <LinePlaneFlyIcon />}
      <AirportDetails>
        <BodyText variant="medium" weight="semi-bold">{displayText}</BodyText>
        <BodyText variant="medium">{airportCode}</BodyText>
      </AirportDetails>
    </Root>
  )
}

export default AirportDropdownOption
